import clsx from "clsx";
import s from "./SearchMobMenu.module.scss";
import ArrowLeftIcon from "../../../../../Icons/ArrowLeftIcon";
import CloseIcon from "../../../../../Icons/CloseIcon";
import { observer } from "mobx-react-lite";
import MainHeaderStore from "../../../../stores/MainHeaderStore";
import { MainHeaderSearchResult } from "../../MainHeaderSearch/ui/components/MainHeaderSearchResult";
import useSearchMobMenu from "../helpers/useSearchMobMenu";
import { MainHeaderSearchResultMob } from "../../MainHeaderSearch/ui/components/MainHeaderSearchResult/ui/MainHeaderSearchResultMob";
import { RefObject, useEffect, useRef } from "react";

interface Props {
  store: MainHeaderStore;
  lockBodyScroll: () => void;
  unlockBodyScroll: () => void;
  inputRef: RefObject<HTMLInputElement>;
}

export const SearchMobMenu: React.FC<Props> = observer(
  ({ store, lockBodyScroll, unlockBodyScroll, inputRef }) => {
    const { onClose, handleOnChange, handleFocus, handleBlur, clear } =
      useSearchMobMenu({ store, lockBodyScroll, unlockBodyScroll });

    return (
      <div className={clsx(s.wrapper, store.isSearchMobOpen && s.active)}>
        <div className={s.top}>
          <div className={s.back} onClick={onClose}>
            <ArrowLeftIcon color="#9797A0" />
          </div>
          <div className={s.field}>
            <input
              ref={inputRef}
              type="text"
              placeholder="Search"
              onChange={handleOnChange}
              onFocus={handleFocus}
              onBlur={handleBlur}
              value={store.searchString}
            />
          </div>
          {store.searchString !== "" && (
            <div className={s.clear} onClick={clear}>
              <CloseIcon />
            </div>
          )}
        </div>
        <div className={s.result}>
          <MainHeaderSearchResultMob mainHeaderStore={store} />
        </div>
      </div>
    );
  }
);
